import * as yup from 'yup';

const chapterValidationSchema = yup.object().shape({
    courseName: yup.string().required('Chapter Name is required'),
});

export default chapterValidationSchema;
